import { IRequirement } from 'APIPackage/DictionariesModule/interfaces/IRequirement';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionaryRequirementSelectOption = makeCreateDictionarySelectOption<IRequirement>('id', 'title');
